/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

@file:Suppress("unused")

package net.sergeych.crypto2

import net.sergeych.bintools.toDump
import net.sergeych.mp_tools.encodeToBase64Url

fun UByteArray.toDump(wide: Boolean = false) = asByteArray().toDump(wide)

fun UByteArray.encodeToBase64Url(): String = asByteArray().encodeToBase64Url()